import React from "react";
import { useTranslation } from "react-i18next";
import { FaPuzzlePiece } from "react-icons/fa";

export default function TechnicalSkillsSection() {
  const { t } = useTranslation();
  const capItems = t('services.capabilities.items', { returnObjects: true });

  return (
    <section id="techstack" className="engagement-section">
      <div className="container py-5">
        <div className="capabilities-box">
          <div className="capabilities-title-row">
            <FaPuzzlePiece className="capabilities-title-icon" aria-hidden="true" />
            <h3 className="capabilities-title">{t('services.capabilities.title')}</h3>
          </div>
          <p className="capabilities-subtitle mb-0">{t('services.capabilities.subtitle')}</p>
          <ul className="capabilities-list">
            {Array.isArray(capItems) && capItems.map((item, i) => {
              const colon = item.indexOf(':');
              if (colon === -1) return <li key={i}>{item}</li>;
              return (
                <li key={i}>
                  <strong>{item.slice(0, colon)}:</strong>{item.slice(colon + 1)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
